import { UpdateEventPropsWithMeta } from '../types'
import store from '@/store'

type EventMetaDisciplinesGenders = Pick<Required<UpdateEventPropsWithMeta>['meta'], 'disciplines'|'genders'|'venues'>

// eslint-disable-next-line complexity, max-lines-per-function
export const getDisciplinesAndGendersUpdates = (event: UpdateEventPropsWithMeta): EventMetaDisciplinesGenders => {
  const castId = event.castId
  const athlete = event.scenesSettings?.athlete
  const updateData: EventMetaDisciplinesGenders = {}
  if (!castId || !athlete) return {}
  const orgEvent = store.state.events.events.find((evt) => evt.id === event.id)
  if (orgEvent) {
    const oldDiscipline = orgEvent.meta?.casts[castId]?.athlete?.discipline
    const oldGender = orgEvent.meta?.casts[castId]?.athlete?.gender
    const oldVenue = orgEvent.meta?.casts[castId]?.athlete?.venue
    if (oldDiscipline === athlete.discipline && oldGender === athlete.gender && oldVenue === athlete.venue) return {}
    const existingCastDisciplines = []
    const existingCastGenders = []
    const existingCastVenues = []
    for (const [cId, castMeta] of Object.entries(orgEvent.meta?.casts ?? {})) {
      if (cId === castId) continue
      if (castMeta.athlete?.discipline) existingCastDisciplines.push(castMeta.athlete.discipline)
      if (castMeta.athlete?.gender) existingCastGenders.push(castMeta.athlete.gender)
      if (castMeta.athlete?.venue) existingCastVenues.push(castMeta.athlete.venue)
    }
    if (oldDiscipline && oldDiscipline !== athlete.discipline && !existingCastDisciplines.includes(oldDiscipline)) {
      updateData.disciplines = { [oldDiscipline]: false }
    }
    if (oldGender && oldGender !== athlete.gender && !existingCastGenders.includes(oldGender)) {
      updateData.genders = { [oldGender]: false }
    }
    if (oldVenue && oldVenue !== athlete.venue && !existingCastVenues.includes(oldVenue)) {
      updateData.venues = { [oldVenue]: false }
    }
  }
  if (athlete.discipline) updateData.disciplines = { ...updateData.disciplines, [athlete.discipline]: true }
  if (athlete.gender) updateData.genders = { ...updateData.genders, [athlete.gender]: true }
  if (athlete.venue) updateData.venues = { ...updateData.venues, [athlete.venue]: true }
  return updateData
}
